<template>
  <div class="pt-14 lg:pt-5 pb-10 flex flex-col justify-center items-center">
    <div class="font-normal text-center mb-5">
      <p class="leading-[26px] text-[16px] text-primary-1">
        {{ t("searchBox.hmSorry") }}!
      </p>
      <span class="leading-[22px] text-[15px] text-gray-1">
        {{ t("searchBox.noResultsFound") }}.
      </span>
    </div>
    <div class="p-4 bg-gray-5 rounded-full">
      <IconNoData class="text-[39px] !mb-0 text-primary-2" />
    </div>
  </div>
</template>

<script setup lang="ts">
const { t } = useI18n();
</script>
